import { type SelectProps, Flex, Select } from "@gravity-ui/uikit";
import { useTolgee } from "@tolgee/react";

import { iconByLanguage, languageOptions } from "./LanguageBlock.constants";

export const LanguagesBlock = ({ ...props }: SelectProps) => {
  const tolgee = useTolgee(["language"]);

  const selectValue = [tolgee.getLanguage() || ""];

  return (
    <Select
      value={selectValue}
      onUpdate={(value) => {
        tolgee.changeLanguage(value[0]);
      }}
      size="l"
      width={"auto"}
      {...props}
    >
      {languageOptions.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          <Flex alignItems={"center"} justifyContent={"space-between"} gap={2}>
            <img
              src={`https://flagicons.lipis.dev/flags/4x3/${iconByLanguage[option.value]}.svg`}
              width={16}
              height={16}
            />
            {option.content}
          </Flex>
        </Select.Option>
      ))}
    </Select>
  );
};
